const { isEmpty } = require('lodash');

module.exports = {
  fields: ({ otherLocations = [] } = {}) => {
    return {
      sortKey: {
        label: 'キー',
        type: 'string',
        validations: {
          required: _ => !isEmpty(_),
          unique: (v, s) => !otherLocations.map(_ => _.sortKey).includes(v),
        },
      },
      name: {
        label: '名称',
        type: 'string',
        validations: {
          required: _ => !isEmpty(_),
        },
      },
    };
  },
};
